import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/authContext";
import { useTalentVolteList, useVoteMutation } from "../../actions/homeActions";
import { useQueryClient } from "@tanstack/react-query";
export default () => {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loadingToHotapi, setLoadingToHotapi] = useState(false);
  const [loadingToNotapi, setLoadingToNotapi] = useState(false);
  const per_page = 100;
  const queryClient = useQueryClient();
  const userId = localStorage.getItem("userId");
  const {
    data: talentVolteList,
    isLoading,
    isError,
    error,
    refetch,
  } = useTalentVolteList(userId, per_page);
  const filteredTalentList = talentVolteList?.data?.vote_images || [];
  const mutation = useVoteMutation(
    setLoadingToHotapi,
    setLoadingToNotapi,
    queryClient,
    setCurrentIndex,
    filteredTalentList
  );
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading Volte talent: {error.message}
        </p>
      </div>
    );
  }

  const handleVotelike = (id) => {
    if (!isLoggedIn) {
      navigate("/login");
    } else {
      setLoadingToHotapi(true);
      mutation.mutate(
        {
          user_voter_id: userId,
          user_votee_id: id,
          like: 1,
        },
        {
          onSuccess: () => {
            refetch(); // Refetch the talentVolteList to update the UI after voting
          },
        }
      );
    }
  };
  const handleVotedislike = (id) => {
    if (!isLoggedIn) {
      navigate("/login");
    } else {
      setLoadingToNotapi(true);
      mutation.mutate(
        {
          user_voter_id: userId,
          user_votee_id: id,
          like: 0,
        },
        {
          onSuccess: () => {
            refetch(); // Refetch the talentVolteList to update the UI after voting
          },
        }
      );
    }
  };
  const bgColor = [
    { id: 1, color: "#017872" },
    { id: 2, color: "#F3C623" },
    { id: 3, color: "#433878" },
  ];

  const getVisibleItems = () => {
    const visibleItems = [];
    const maxItemsToShow =
      filteredTalentList.length < 2 ? 1 : filteredTalentList.length < 3 ? 2 : 3;

    for (let i = 0; i < maxItemsToShow; i++) {
      if (filteredTalentList.length === 0) break;

      const index = (currentIndex + i) % filteredTalentList.length;
      const item = filteredTalentList[index];

      if (item) {
        visibleItems.push({ ...item, bgColor: bgColor[i]?.color }); // fallback color
      }
    }
    return visibleItems;
  };

  return {
    talentVolteList,
    filteredTalentList,
    isLoading,
    getVisibleItems,
    handleVotelike,
    loadingToHotapi,
    handleVotedislike,
    loadingToNotapi,
  };
};
